import { useEffect, useMemo, useState } from "react";

const stripHtml = (value = "") => {
  if (!value) return "";
  const div = document.createElement("div");
  div.innerHTML = value.replace(/<br\s*\/?>/gi, "\n");
  return (div.textContent || div.innerText || "").trim();
};

const getWordCount = (value = "") =>
  value
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .length;

export default function ReplyModal({
  open,
  title = "Reply to Question",
  helpText = "Write between 15 and 500 words.",
  placeholder = "Write your reply here...",
  initialValue = "",
  submitting = false,
  submitLabel = "Submit Reply",
  onClose,
  onSubmit,
}) {
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setText(stripHtml(initialValue || ""));
    setError("");
  }, [open, initialValue]);

  const wordCount = useMemo(() => getWordCount(text), [text]);

  const handleSubmit = async () => {
    setError("");
    try {
      await onSubmit(text);
    } catch (submitError) {
      setError(submitError?.message || "Unable to submit reply right now.");
    }
  };

  if (!open) return null;

  return (
    <div
      className="reply-modal-overlay"
      onClick={(event) => {
        if (event.target.classList.contains("reply-modal-overlay")) {
          onClose();
        }
      }}
    >
      <div className="reply-modal-card">
        <button
          type="button"
          className="reply-modal-close"
          onClick={onClose}
        >
          x
        </button>
        <h3>{title}</h3>
        <p className="reply-modal-help">{helpText}</p>
        <textarea
          value={text}
          onChange={(event) => {
            setText(event.target.value);
            if (error) setError("");
          }}
          onPaste={(event) => {
            event.preventDefault();
            setError("Pasting is disabled. Please type your reply manually.");
          }}
          onCopy={(event) => event.preventDefault()}
          onCut={(event) => event.preventDefault()}
          onDrop={(event) => {
            event.preventDefault();
            setError("Pasting is disabled. Please type your reply manually.");
          }}
          placeholder={placeholder}
          rows={8}
          maxLength={4000}
        />
        <div className="reply-modal-footer">
          <span className="reply-modal-counter">
            {wordCount} words
          </span>
          {error && <p className="reply-modal-error">{error}</p>}
        </div>
        <div className="reply-modal-actions">
          <button
            type="button"
            className="reply-modal-btn reply-modal-btn--secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="modal-btn modal-btn-custom"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Submitting..." : submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
